import { Component, ElementRef } from '@angular/core';
import { ApiService } from '../core/services';
import { startCase } from 'lodash';

@Component({
    template: require('./amber-classifications.component.html'),
    styles: [require('./amber-classifications.component.scss')],
    selector: 'amber-classifications'
})
export class AmberClassificationsComponent {
    id: number;

    // typeClassifications$: Observable<any>;
    typeData;
    typeLoaded = false;

    widthData;
    widthLoaded = false;

    fishData;
    fishLoaded = false;

    chartOptions = {
        legend: {
            labels: {
                boxWidth: 12
            }
        },
        plugins: {
            datalabels: {
                color: '#FFF',
                font: {
                    weight: 'bold'
                }
            }
        }
    };

    constructor(elem: ElementRef, private api: ApiService) {
        this.id = parseFloat(elem.nativeElement.getAttribute('barrierId'));

        this.api.getTypeResults(this.id).subscribe(data => {
            data.labels = data.labels.map(label => startCase(label));
            this.typeData = data;
            this.typeLoaded = true;
        });

        this.api.getWidthResults(this.id).subscribe(data => {
            data.labels = data.labels.map(label => startCase(label));
            this.widthData = data;
            this.widthLoaded = true;
        });

        this.api.getFishResults(this.id).subscribe(data => {
            data.labels = data.labels.map(label => startCase(label));
            this.fishData = data;
            this.fishLoaded = true;
        });

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/amber-classifications/amber-classifications.component.ts